import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'tracker-admin-notifications',
  template: require('./admin.notifications.component.html')
})
export class TrackerAdminNotificationsComponent {
  @Input() tracker: any;

  @Output() onUpdate: EventEmitter<any> = new EventEmitter<any>();

  protected onSubmitUpdate($event) {
    this.onUpdate.emit({notification: 'submit', value: $event});
  }

  protected onBrowseUpdate($event) {
    this.onUpdate.emit({notification: 'browse', value: $event});
  }
}
